<template>
  <div id="app">
    <router-view />
    <!-- 开发环境显示主题切换器 -->
    <ThemeSwitcher />
    <footer class="app-footer">
      <a href="https://beian.miit.gov.cn/" target="_blank" class="icp-text">
        <span class="icp-text">浙ICP备2024062069号-1</span>
      </a>
    </footer>
  </div>
</template>

<script>
import ThemeSwitcher from './components/ThemeSwitcher.vue'

export default {
  name: 'App',
  components: {
    ThemeSwitcher
  },
  computed: {
    isDevelopment() {
      return process.env.NODE_ENV === 'development'
    }
  }
}
</script>

<style>
#app {
  min-height: 100vh;
}

/* ICP 备案 Footer 样式 */
.app-footer {
  padding: 5px 5px;
  text-align: center;
  background: transparent;
  margin-top: auto;
}

.icp-text {
  margin: 0;
  font-size: 10px;
  color: #0f0d0d;
  line-height: 1.5;
  text-decoration: none;
  opacity: 0.7;
  transition: all 0.3s ease;
}

a.icp-text {
  display: inline-block;
}

a.icp-text:hover {
  color: #1c1b1b;
  opacity: 1;
}
</style>
